import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface PatternBackgroundProps {
  pattern: "basket" | "butterfly" | "palm" | "woven";
  children: ReactNode;
  className?: string;
}

const PatternBackground = ({ pattern, children, className }: PatternBackgroundProps) => {
  const getPatternClass = () => {
    switch (pattern) {
      case "basket":
        return "bg-[url('/src/assets/pattern-basket.jpg')] bg-cover bg-center bg-no-repeat";
      case "butterfly":
        return "bg-[url('/src/assets/pattern-butterfly.jpg')] bg-cover bg-center bg-no-repeat";
      case "palm":
        return "bg-[url('/src/assets/pattern-palm.jpg')] bg-cover bg-center bg-no-repeat";
      case "woven":
        return "bg-[url('/src/assets/pattern-woven.jpg')] bg-cover bg-center bg-no-repeat";
      default:
        return "";
    }
  };

  return (
    <div className={cn("relative min-h-screen", getPatternClass(), className)}>
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default PatternBackground;